import TranslationProvider from './TranslationProvider';

export { TranslationProvider };

export const translationProvider = new TranslationProvider();
